module.exports = __webpack_public_path__ + "img/客户logo_1.01699e3e.png";